import type { CSSProperties } from 'react';

/**
 * A style object that also carries CSS custom properties.
 *
 * React types the `style` prop as `CSSProperties`, which has no index
 * signature for `--custom` names — so an object literal containing one fails
 * the excess-property check even though the DOM accepts it happily. The studio
 * sets a variable in 13 places (accent swatches, tile grids, the filmstrip's
 * section colours), and this is the ONE named cast for all of them rather than
 * an anonymous `as CSSProperties` scattered across eight files.
 */
export type StyleWithVars = CSSProperties & Record<`--${string}`, string | number | undefined>;

/** Use as `style={cssVars({ '--swatch': hex })}`. */
export const cssVars = (style: StyleWithVars): CSSProperties => style as CSSProperties;
